import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { SelectValueType } from 'ui/selects';

const additionalSymbol = '+';

export const getMultiValueInputLabelVariables = <TValue extends SelectValueType>(
  values: SelectOption<TValue>[],
  valuesLimit: number,
) => {
  const renderedValues = values.slice(0, valuesLimit);
  const cutOffValuesLength = values.slice(valuesLimit, values.length).length;

  const firstValue = renderedValues.map(({ title }) => title)[0];
  const cutOffValuesLabel = additionalSymbol.concat(cutOffValuesLength.toString());
  return {
    firstValue,
    cutOffValuesLabel,
    cutOffValuesLength,
  };
};
